import React from 'react';
import { Chart } from "react-google-charts";


const Tokenomics = () => {

  const tokenProperties = [
    {
      name: 'Token Ticker',
      value: 'TBA'
    },
    {
      name: 'Token Address',
      value: 'TBA'
    },
    {
      name: 'Supply Cap',
      value: 'TBA'
    },
    {
      name: 'Snapshot',
      value: 'TBA'
    },
    {
      name: 'Inflation',
      value: 'TBA'
    },
    {
      name: 'Deployed On',
      value: 'TBA'
    },
    {
      name: 'Transferrable to Etherum Mainnet',
      value: 'TBA'
    },
  ]

  const data = [
    ["category", "percentage"],
    ["Ecosystem Growth", 39],
    ["Public", 5.28],
    ["Seed", 5.72],
    ["Team", 20],
    ["Community", 30],
  ];

  const options = {
    title: "",
    is3D: false, // Enables 3D view
    // pieHole: 0.4, // Will be ignored if is3D is set to true
    // pieStartAngle: 100, // Rotates the chart
    // sliceVisibilityThreshold: 0.02, // Hides slices smaller than 2%
    legend: {
      position: "none",
      // alignment: "center",
    },
    colors: ["#FF5500", "#F500C3", "#9E00FF", "#00A3FE", "#00DA79"],
  };

  return (
    <main id="tokenomic" className="flex flex-col justify-center">
      <div className="container mx-auto py-10 md:py-20 px-4">
        <div className="flex justify-center">
          <h1 data-text="Tokenomics" className="zk-title text-[1.5rem] md:text-[2rem] font-russo uppercase mb-4 md:mb-10 text-white text-shadow">Tokenomics</h1>
        </div>


        <div className="grid grid-cols-1 gap-4">
          <div className="table bg-[#9D00FF] p-5 pt-0 rounded-3xl border-4 border-black max-w-[800px] mx-auto">
            <div className="font-medium uppercase py-2 pt-3 text-center text-white font-russo text-[1.5rem]">Token Properties</div>
            <table className="min-w-full bg-black rounded-xl overflow-hidden border-black border-4 table-tokenomic">
              <tbody>
                {tokenProperties.map((item, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 title font-medium font-russo uppercase bg-[#220078] text-white">{item.name}</td>
                    <td className="py-2 px-4 value text-[#2F197B] font-medium font-russo">{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* <div className="p-5 bg-[#9D00FF] border-4 border-black rounded-3xl">
            <div className="rounded-2xl overflow-hidden">
              <Chart
                chartType="PieChart"
                data={data}
                options={options}
                width={"400px"}
                height={"400px"}
              />
            </div>
          </div> */}
        </div>
      </div>
    </main>
  );
};

export default Tokenomics;